// Shared full-screen plane loading overlay for flight search → results flow.

const PLANE_SVG = '<svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>';

export function loadingOverlayHTML() {
  return `<div class="fs-loading-overlay" data-flight-search-loading role="status" aria-live="polite">
    <div class="fs-loading-overlay__icon-wrap">
      <div class="fs-loading-overlay__icon-box">
        <div class="fs-loading-overlay__plane">${PLANE_SVG}</div>
        <div class="fs-loading-overlay__scan"></div>
      </div>
    </div>
    <p class="fs-loading-overlay__title">Finding your flights<span data-flight-search-loading-dots></span></p>
    <p class="fs-loading-overlay__subtitle">Scanning 300+ routes across Europe for the best prices</p>
    <div class="fs-loading-overlay__routes" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span></div>
  </div>`;
}

let dotsTimer = null;

export function showFlightSearchLoading() {
  let overlay = document.querySelector('[data-flight-search-loading]');
  if (!overlay) {
    document.body.insertAdjacentHTML('beforeend', loadingOverlayHTML());
    overlay = document.querySelector('[data-flight-search-loading]');
  } else {
    overlay.hidden = false;
  }
  const dotsEl = overlay?.querySelector('[data-flight-search-loading-dots]');
  if (dotsTimer) clearInterval(dotsTimer);
  let dots = '';
  dotsTimer = setInterval(() => {
    dots = dots.length >= 3 ? '' : `${dots}.`;
    if (dotsEl) dotsEl.textContent = dots;
  }, 500);
  return overlay;
}

export function hideFlightSearchLoading() {
  if (dotsTimer) {
    clearInterval(dotsTimer);
    dotsTimer = null;
  }
  document.querySelectorAll('[data-flight-search-loading]').forEach((el) => el.remove());
}
